import { ResolveFn } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { AppState } from '@fcom/core/interfaces';
import { profileOrUndefinedIfNotLoggedIn } from '@fcom/core/selectors';

export const corporateUserIdResolver: ResolveFn<string> = (): Observable<string> => {
  const store$ = inject(Store<AppState>);
  const platform = inject(PLATFORM_ID);

  if (isPlatformServer(platform)) {
    return;
  }
  return store$.pipe(
    profileOrUndefinedIfNotLoggedIn(),
    map((userProfile) => userProfile?.corporate?.userId)
  );
};
